import React from 'react'
import { Tooltip } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { injectIntl } from 'react-intl'
import { withProfile } from 'redux/enhancers'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import AllAncestors from './AllAncestors'

import style from './style.module.scss'

class AncestorInfo extends React.Component {
  render() {
    if (!this.props.user) {
      return null;
    }

    const { formatMessage } = this.props.intl;

    if (!this.props.user.ancestor) {
      return (
        <div className={style.ancestorInfo}>
          <h3>{formatMessage({ id: 'page.dashboard.ancestors.title' })}</h3>
          <div className={style.name}>
            {formatMessage({ id: 'page.dashboard.ancestors.nodata' })}
          </div>
        </div>
      )
    }

    const { ancestor } = this.props.user;

    return (
      <div className={style.ancestorInfo}>
        <h3>{formatMessage({ id: 'page.dashboard.ancestors.title' })}</h3>
        <div className={style.name}>
          <Tooltip title={ancestor.login ? `@${ancestor.login}` : ''}>
            {ancestor.firstname ? ancestor.firstname : ''}&nbsp;
            {ancestor.lastname ? ancestor.lastname : ''}&nbsp;
          </Tooltip>
        </div>
        <div className={style.contacts}>
          {ancestor.email && <span><MailOutlined />{ancestor.email}</span>}
        </div>
        <AllAncestors />
      </div>
    )
  }
}

export default errorBoundaryEnhancer(injectIntl(withProfile(AncestorInfo)))
